import React, { useEffect, useRef, useState } from "react";
import { set, useForm } from "react-hook-form";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import ReactMarkdown from "react-markdown";
import getBrowserFingerprint from "get-browser-fingerprint";
import { browserName, isIOS } from "react-device-detect";
import loadericon from "../assets/img/Rollingnew.svg";
import { Base64 } from 'js-base64';
import Multiselect from 'multiselect-react-dropdown';

const Traineedetails = () => {
  // fingerprint stored in a ref so it's stable across renders
  const fingerprintRef = useRef(getBrowserFingerprint());

  const {
    register,
    reset,
    formState: { errors },
    handleSubmit,
    clearErrors,
    setValue,
    trigger,
    getValues,
  } = useForm({
    mode: "onSubmit",
  });

  const { t } = useTranslation(["certificationFormAgency", "certificationView", "Footer"]);
  const history = useNavigate();
  const submitbutton = useRef(null);
  const [isloader, setIsloader] = useState(false);
  const [emailaddressrequired, setEmailaddressrequired] = useState(false);
  const [fullnamerequired, setFullnamerequired] = useState(false);
  const [btnDisable, setbtnDisable] = useState(true);
  const [submitted, setsubmitted] = useState(false);
  const [selectedBrands, setSelectedBrands] = useState([]);
  const [verified, setVerified] = useState(false);
  // start with full name disabled
  const [fullNameDisabled, setFullNameDisabled] = useState(true);
  const [nextLoading, setNextLoading] = useState(false);

  useEffect(() => {
    const agencyEmail = localStorage.getItem("agencyEmail");
    if (agencyEmail) {
      setValue("emailPromoterAgency", agencyEmail);
    }
  }, [setValue]);

  const [showErrorMessage, setErrorMsg] = useState("");
  const handleNext = async (e) => {
    e && e.preventDefault();
    // validate email field first
    const valid = await trigger("emailAddress");
    if (!valid) {
      return;
    }
    setNextLoading(true);
    try {
      const emailFromField = getValues("emailAddress");
      if (emailFromField) {
        localStorage.setItem("agencyEmail", emailFromField);
        setValue("emailPromoterAgency", emailFromField);
      }
      const payload = {
        id: localStorage.getItem("aGencyID"),
        email: localStorage.getItem("agencyEmail"),
      };
      const res = await axios.post(
        process.env.REACT_APP_API_ENDPOINT + "/varifyagencyemail",
        payload
      );


      if (res && res.data && res.data[0].status === true) {
        setVerified(true);
        setFullNameDisabled(false);
        setNextLoading(false);
      } else {
        setNextLoading(false);
      }
    } catch (err) {
  setNextLoading(false);
  // Check if err has response message or use generic message
  const errorMsg = err.response?.data?.msg || err.msg || "An error occurred";
  setErrorMsg(errorMsg);
  setTimeout(() => {
    setErrorMsg("");
  }, 10000);
}
  };

  const getCaertificateTag = (id, key) => {
    const jsondata = Object.values(
      t("certificateContent", { returnObjects: true, ns: "certificationView" })
    );
    const data = jsondata.find((item) => {
      return item.id === id && item.key !== "";
    });
    return data ? data[key] : "";
  };

  const getFooterTag = (id, key) => {
    const jsondata = Object.values(
      t("LeftFooter", { returnObjects: true, ns: "Footer" })
    );
    const data = jsondata.find((item) => {
      return item.id === id && item.key !== "";
    });
    return data ? data[key] : "";
  };

  const getdata = (id, field_type, key, segment) => {
    const jsondata = Object.values(t(segment, { returnObjects: true }));
    const data = jsondata.find((item) => {
      return item.id === id && item.fieldType === field_type && item.key !== "";
    });
    return data ? data[key] : "";
  };

  const [certificateData, setCertificateData] = useState('new');
  const onSubmit = async (data) => {
    const eamilcheck = localStorage.getItem("lastEmailAddress");

    if (eamilcheck !== data["emailAddress"]) {
      const keepKeys = ['lanCode', 'lanName', 'lanId', 'aGencyID', 'aGencyCcod', 'agencyEmail'];
      Object.keys(localStorage).forEach(k => {
        if (!keepKeys.includes(k)) {
          localStorage.removeItem(k);
        }
      });
    }

    localStorage.setItem("lastEmailAddress", data["emailAddress"]);

    if (!submitted) {
      try {
        setbtnDisable(true);
        setIsloader(true);
        setsubmitted(true);
        // store plain email for later use (encoded)
        localStorage.setItem("emailAddress", Base64.encode(data["emailAddress"]))

        const res = await axios.post(
          process.env.REACT_APP_API_ENDPOINT + "/submitagencydata",
          {
            fullName: data["fullName"],
            emailAddress: data["emailAddress"],
            idPromoterAgency: localStorage.getItem("aGencyID"),
            agencyuniqueCodeUsed: localStorage.getItem("aGencyCcod"),
            idlanguage: localStorage.getItem("lanId"),
            useremail: t("UserEmail", { returnObjects: true }),
            agencypromoteremail: t("AgencyPromoterEmail", { returnObjects: true }),

            HeaderTag1: getCaertificateTag(
              "h2_brandPromotor_tr_cert",
              "certificatetagTag1"
            ),
            HeaderTag2: getCaertificateTag(
              "h2_brandPromotor_tr_cert",
              "certificatetagTag2"
            ),
            NameTag: getCaertificateTag("plain_text_NAME_CV", "value"),
            DateTag: getCaertificateTag("plain_text_DATE_CV", "value"),
            CertifiacteNoTag: getCaertificateTag("plain_text_CSN_CV", "value"),
            AgencyNameTag: getCaertificateTag("plain_text_BPA_CV", "value"),
            EmailFooterDes: getFooterTag("rich_text_footer_PH1", "value")
          }
        );
        let certificateDataFlag = res.data.flag || 'new';
          localStorage.setItem("certificateDataFlag", certificateDataFlag);
        if (res && (res.data.status === 1 || res.data.status === "1")) {
          setCertificateData(res.data.flag);
          localStorage.setItem("certificateData", res.data.flag);
          const promoter = res.data.values?.promoteragency || {};
          const plain_text_BPA_CV_WithCity =
            promoter.AgencyCity && promoter.AgencyCity !== ""
              ? promoter.PromoterAgencyName + ",\n" + promoter.AgencyCity
              : promoter.PromoterAgencyName || "";

          const plain_text_BPA_CV =
            promoter.AgencyLocation && promoter.AgencyLocation !== ""
              ? plain_text_BPA_CV_WithCity + (promoter.AgencyCity ? ", " : ",\n") + promoter.AgencyLocation
              : plain_text_BPA_CV_WithCity;

          localStorage.setItem("plain_text_NAME_CV", res.data.values.fullName || "");
          localStorage.setItem("plain_text_DATE_CV", Base64.encode(res.data.values.certificationDate || ""));
          localStorage.setItem("plain_text_CSN_CV", Base64.encode(res.data.values.certificateNumber || ""));
          localStorage.setItem("plain_text_BPA_CV", Base64.encode(plain_text_BPA_CV || ""));

          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: "customEvent",
            eventCategory: "Button",
            eventAction: "Button/Page View",
            eventLabel: "GOAL",
            eventValue: "Successful",
          });

          localStorage.setItem("AID", Base64.encode(fingerprintRef.current + "A6"));
          history("/agency");
          window.location.reload();
        } else {
          // store payload for later
          const payload = {
            fullName: data["fullName"],
            emailAddress: data["emailAddress"],
            idPromoterAgency: localStorage.getItem("aGencyID"),
            agencyuniqueCodeUsed: localStorage.getItem("aGencyCcod"),
            idlanguage: localStorage.getItem("lanId"),
            useremail: t("UserEmail", { returnObjects: true }),
            agencypromoteremail: t("AgencyPromoterEmail", { returnObjects: true }),

            HeaderTag1: getCaertificateTag(
              "h2_brandPromotor_tr_cert",
              "certificatetagTag1"
            ),
            HeaderTag2: getCaertificateTag(
              "h2_brandPromotor_tr_cert",
              "certificatetagTag2"
            ),
            NameTag: getCaertificateTag("plain_text_NAME_CV", "value"),
            DateTag: getCaertificateTag("plain_text_DATE_CV", "value"),
            CertifiacteNoTag: getCaertificateTag("plain_text_CSN_CV", "value"),
            AgencyNameTag: getCaertificateTag("plain_text_BPA_CV", "value"),
            EmailFooterDes: getFooterTag("rich_text_footer_PH1", "value")
          };

          localStorage.setItem("payloadsubmit", Base64.encode(JSON.stringify(payload)));

          if (res && res.data) {
            localStorage.setItem("idagencyTraineData", res.data.data?.idagencyTraineData || "");

            const valuesFlag = res.data.values;
            if (valuesFlag === "TRAINING_INCOMPLETE") {
              localStorage.setItem("AID", Base64.encode(fingerprintRef.current + "A3"));
            } else if (valuesFlag === "QUIZZ_INCOMPLETE") {
              localStorage.setItem("AID", Base64.encode(fingerprintRef.current + "A4"));
            } else if (valuesFlag === "SURVEY_INCOMPLETE") {
              localStorage.setItem("AID", Base64.encode(fingerprintRef.current + "A5"));
            } else {
              localStorage.setItem("AID", Base64.encode(fingerprintRef.current + "A1"));
            }
          }

          history("/agency");
          window.location.reload();
        }
      } catch (error) {
        setbtnDisable(false);
        setIsloader(false);
        setsubmitted(false);

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "customEvent",
          eventCategory: "Button",
          eventAction: "Button/Page View",
          eventLabel: "GOAL",
          eventValue: "Error",
        });
        if (error.response) {
          // you can log error.response.data.msg here for debugging
        }
      }
    }
  };

  useEffect(() => {
    if (browserName === "Safari" || isIOS) {
      const strongs = document.querySelectorAll("strong");
      if (strongs.length) {
        strongs.forEach((strong) => {
          strong.setAttribute("style", "font-family:urw_geometricbold");
        });
      }
    }
  }, []);

  useEffect(() => {
    try {
      const currenttime = new Date();
      const mDsT = localStorage.getItem("mDsT");
      if (mDsT) {
        try {
          const decoded = mDsT ? Base64.decode(mDsT) : null;
          if (decoded) {
            const startedtime = new Date(decoded);
            const checkseconds = (currenttime.getTime() - startedtime.getTime()) / 1000;

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              event: "customEvent",
              eventCategory: "Button",
              eventAction: "Traniee Details Page",
              eventLabel: "Training Completed",
              eventValue: checkseconds + " seconds",
            });
          }
        } catch (err) {
          // invalid stored value; ignore
        }
        localStorage.removeItem("mDsT");
      }
    } catch (err) {
      // swallow errors - do not block the page
    }

    window.scrollTo(0, 0);
  }, []);

  const [nextBtnDisabled, setNextBtnDisabled] = useState(true);
  return (
    <>
      <section className="header2 theme-space px-lg-5 autofocus">
        <div className="container">
          <div className="row justify-content-center align-items-center">
            <div className="col-12 col-md-10 col-lg-10">
              <div className="text-wrapper">
                {Object.values(t("topContent", { returnObjects: true })).map(
                  (item) =>
                    item.fieldType === "h1" && item.value !== "" ? (
                      <h1 key={item.id} className="mb-5">
                        <ReactMarkdown components={{ p: React.Fragment, h1: React.Fragment, h2: React.Fragment, h3: React.Fragment, h4: React.Fragment, h5: React.Fragment, h6: React.Fragment }}>
                          {item.value}
                        </ReactMarkdown>
                      </h1>
                    ) : (
                      ""
                    )
                )}
                {Object.values(t("topContent", { returnObjects: true })).map(
                  (item) =>
                    item.fieldType === "plain_text" && item.value !== "" ? (
                      <p
                        key={item.id}
                        className="col-12 col-md-8 pe-lg-5 me-lg-5 page3topplainteext"
                      >
                        <ReactMarkdown components={{ p: React.Fragment }}>
                          {item.value}
                        </ReactMarkdown>
                      </p>
                    ) : (
                      ""
                    )
                )}
              </div>
            </div>
            <div className="col-12 col-md-2 col-lg-2"> </div>
          </div>
        </div>
      </section>
      <section className="theme-space px-lg-5 mb-3">
        <div className="container">
          <div className="row justify-content-center align-items-center">
            <div className="col-12 col-md-6 col-lg-5">
              <div className="text-wrapper">
                {showErrorMessage !== "" && 
                <div class="alert alert-danger" role="alert" style={{padding : "5px 10px"}}>
                  {Object.values(t("emailErrorMsg", { returnObjects: true })).map(
                  (item) =>
                    item.fieldType === "h1" && item.value !== "" ? (
                      <p
                        key={item.id}
                        className="col-12 page3topplainteext"
                      >
                        <ReactMarkdown components={{ p: React.Fragment }}>
                          {item.value}
                        </ReactMarkdown>
                      </p>
                    ) : (
                      ""
                    )
                )}
                </div>
                }

                <form onSubmit={handleSubmit(onSubmit)}>
                  <>
                    <div className="position-relative">
                      <label htmlFor="emailAddress">
                        <ReactMarkdown components={{ p: React.Fragment }}>
                          {getdata(
                            "emailAddress",
                            "input_email",
                            "title",
                            "formContent"
                          )}
                        </ReactMarkdown>
                      </label>
                      <input
                        {...register("emailAddress", {
                          required: true,
                          pattern:/[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/,
                          onChange: (e) => {
                            if (e.target.value === "") {
                              // setEmailaddressrequired(false);
                              // setbtnDisable(true);
                              // clearErrors("emailAddress");

                              setEmailaddressrequired(false);
                              setNextBtnDisabled(true); // Disable Next if no email
                              clearErrors("emailAddress");
                            } else {
                              // setEmailaddressrequired(true);
                              // clearErrors("emailAddress");
                              setEmailaddressrequired(true);
                              setNextBtnDisabled(false); // Enable Next if email entered
                              clearErrors("emailAddress");
                              if(fullnamerequired){                               
                                setbtnDisable(false);
                              }
                            }
                          },
                        })}
                        maxLength={75}
                        className="w-100 px-3 py-2 mb-4"
                        placeholder={getdata(
                          "emailAddress",
                          "input_email",
                          "placeholder",
                          "formContent"
                        )}
                        autoComplete="off"
                        id="emailAddress"
                      />

                      {errors.emailAddress?.type === "pattern" && (
                        <span className="error">
                          {getdata(
                          "emailAddress",
                          "input_email",
                          "errorText",
                          "formContent"
                        )}
                        </span>
                      )}
                    </div>
                    <div className="position-relative">
                      <label htmlFor="fullName">
                        <ReactMarkdown components={{ p: React.Fragment }}>
                          {getdata(
                            "fullName",
                            "input_text",
                            "title",
                            "formContent"
                          )}
                        </ReactMarkdown>
                      </label>
                      <input
                        {...register("fullName", {
                          required: true,
                          minLength: 2,
                          pattern: /^(?! )(?!.* $)(?!.* {2})[\p{L}\s'\-.]+$/u,

                          onChange: (e) => {
                            if (e.target.value === "") {
                              setFullnamerequired(false);
                              setbtnDisable(true);
                              clearErrors("fullName");
                            } else {
                              setFullnamerequired(true);
                              if(emailaddressrequired){
                                setbtnDisable(false);
                              }
                            }
                          },
                        })}
                        maxLength={30}
                        className="w-100 px-3 py-2 mb-4"
                        placeholder={getdata(
                          "fullName",
                          "input_text",
                          "placeholder",
                          "formContent"
                        )}
                        autoComplete="off"
                        id="fullName"
                        disabled={fullNameDisabled}
                      />

                      {errors.fullName?.type === "pattern" && (
                        <span className="error">
                          {getdata(
                          "fullName",
                          "input_text",
                          "errorText",
                          "formContent"
                        )}
                        </span>
                      )}


                    {errors.fullName?.type === "minLength" && (
                        <span className="error">
                          {getdata(
                          "fullName",
                          "input_text",
                          "errorText",
                          "formContent"
                        )}
                        </span>
                      )}
                    </div>
                  </>
                  {verified === false ? (
                    // Next button - does not submit the form
                    <button
                      type="button"
                      aria-label="Next"
                      onClick={handleNext}
                      // disabled={nextLoading}
                      disabled={nextLoading || nextBtnDisabled}
                      className="faq-button"
                    >
                      {nextLoading ? <img className="loaderbtnimg" width={25} height={25} src={loadericon} alt="loading"/> : "Next"}
                    </button>
                  ) : (
                    // existing mapped submit button(s) when verified
                    Object.values(t("formContent", { returnObjects: true })).map(
                      (item) =>
                        item.fieldType === "button" && item.value !== "" && item.value !== "NEXT" ? (
                          <button
                            type="submit"
                            aria-label={item.value}
                            ref={(ref) => (submitbutton.current = ref)}
                            disabled={btnDisable}
                            key={item.id}
                            className="faq-button">                       
                            <ReactMarkdown components={{ p: React.Fragment }}>
                              {item.value}
                            </ReactMarkdown> {isloader ? <img className="loaderbtnimg" width={25}  height={25} src={loadericon} alt="loading"/>: ""}
                          </button>
                        ) : (
                          ""
                        )
                    )
                  )}

                  <br />
                 
                </form>
              </div>
            </div>
            <div className="col-12 col-md-6 col-lg-7 image-wrapper"> </div>
          </div>
        </div>
      </section>
    </>
  );
};
export default Traineedetails;
